module.exports = __webpack_public_path__ + "static/media/img-4ea624ee.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif/h-edge-2.gif
// module id = 5271
// module chunks = 39